import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  mapContainer: {
    display: 'flex',
    minHeight: '300px',
    height: '500px',
    width: '100%',
    '@media (max-width: 640px)': {
      height: '321px',
      width: '100%',
    },
  },
}));
